module.exports = __webpack_public_path__ + "img/certificate-road_crossing.e5057108.png";